// extracted by mini-css-extract-plugin
export var errorIcon = "_py-1";
export var nameLogo = "_py-0";